import { useQuery } from '@tanstack/react-query';
import { getLeads } from 'api/leads';
import { queryClient } from 'react-query';
import { PaginatedData } from 'models/PaginatedData';
import { LeadApiResponse } from 'models/Lead';
import { CampaignType } from 'models/Campaign';
import { API_PATHS } from 'api';

type LeadsParams = {
  campaignId?: string;
  [key: string]: any;
  campaignType?: CampaignType;
};

const fetchLeads = async (params: LeadsParams) => {
  const { campaignId, campaignType, ...rest } = params || {};

  const path =
    params?.campaignType === CampaignType.Personal
      ? API_PATHS.personalCampaigns.getPersonalCampaignLeads(params?.campaignId)
      : getLeads();
  return queryClient.fetchQuery<PaginatedData<LeadApiResponse>>({
    queryKey: [path, { limit: 10, campaignId, ...rest }],
  });
};

const useLeads = (params: LeadsParams) => {
  const key =
    params?.campaignType === CampaignType.Personal ? 'personal-leads' : 'leads';
  return useQuery({
    queryKey: [key, { limit: 10, ...params }],
    queryFn: () => fetchLeads(params),
    enabled: !!params?.campaignId,
    gcTime: 0,
  });
};

export default useLeads;
